(function () {
  function initShopCategory(section) {
    const slider = section.querySelector('[class*="luxury-slider"]');
    if (!slider) return;
    if (slider.swiper) { slider.swiper.destroy(true, true); }
    const nextBtn = section.querySelector('[class*="luxury-next"]');
    const prevBtn = section.querySelector('[class*="luxury-prev"]');
     new Swiper(slider, {
      loop: true,
      initialSlide: window.innerWidth < 768 ? 1 : 0,
      spaceBetween: 0,
      slidesPerView: 1,
      watchSlidesProgress: true,
      grabCursor: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          initialSlide: 0
        }
      }
    });
  }

  function initAll() {
    document
      .querySelectorAll('.luxury-slider-section')
      .forEach(function (section) {
        initShopCategory(section);
      });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initShopCategory(event.target);
  });
  document.addEventListener('shopify:section:reorder', initAll);
})();